module.exports = __webpack_public_path__ + "static/RoslindaleText-Italic-ab42e1166a1a12f097a27e15cfd118eb.woff2";